// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-07-18T10:35:20Z                      #

// ##############################################################

import {utils} from "@mc/mc-legacy";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch, generateUrl} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 * Created by Marbes Consulting jaroslav.hudec@marbes.cz / 24.08.2018. Generated from cz.marbes.cgo.controller.ObjednavkaController.
 */
export default class ObjednavkaApi {
    /**
     * Přeřazení objednávky na jinou pobočku. @param objednavkaId id obj @param pobockaId nová pobočka @return výsledný objekt
     *
     * @param objednavkaId 
     * @param pobockaid 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaAkceResultVO
     */
    static updateObjednavkaPobocka(objednavkaId, pobockaid) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/zmenapobocka`;
        const headers = undefined;
        const params = { pobockaid };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, 0, headers));
    }

    /**
     * Tisk finálního dokladu objednávky @param objednavkaId id objednávky @param response objekt pro návrat @throws IOException chyba při zpracování
     *
     * @param objednavkaId 
     */
    static tiskFinalDoklad(objednavkaId) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/tiskFinalDoklad`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Poskytnutí štítků z evidence dopravy
     *
     * @param objednavkaId 
     */
    static tiskDopravaStitkyBaliky(objednavkaId) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/objednavkadoprava/tiskStitky`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param objednavkaId 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaRightsVO
     */
    static getObjednavkaRights(objednavkaId) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/rights`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Aktualizace položky na existující objednávce @param objednavkaId id objednávky @param polozkaVO aktualizovaný objekt položky objednávky @return aktualizovaná objednávka
     *
     * @param objednavkaId 
     * @param polozkaVO 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaPolozkaVO
     */
    static validateObjednavkaPolozka(objednavkaId, polozkaVO) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/polozky/validuj`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, polozkaVO, headers));
    }

    /**
     * Aktualizace položky na existující objednávce @param objednavkaId id objednávky @param objednavkaPolozkaId id položky objednávky @param polozkaVO aktualizovaný objekt položky objednávky @return aktualizovaná objednávka
     *
     * @param objednavkaId 
     * @param objednavkaPolozkaId 
     * @param polozkaVO 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaAkceResultVO
     */
    static updateObjednavkaPolozka(objednavkaId, objednavkaPolozkaId, polozkaVO) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/polozky/${objednavkaPolozkaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, polozkaVO, headers));
    }

    /**
     * Založení objednávky dopravy @param objVO doplňující informace k objednávce dopravy. @return výsledný objekt objednávky
     *
     * @param objednavkaId 
     * @param objVO 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaAkceResultVO
     */
    static createObjednavkaDoprava(objednavkaId, objVO) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/objednavkadoprava`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, objVO, headers));
    }

    /**
     * Vrátí objednávku podle předaného ID @return objednáveka pro přehled
     *
     * @param objednavkaId 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaVO
     */
    static getObjednavka(objednavkaId) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Poskytnutí štítků z evidence dopravy
     *
     * @param objednavkaId 
     */
    static tiskDopravaStitkyBalikyOk(objednavkaId) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/objednavkadoprava/tiskStitkyOk`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, 0, headers));
    }

    /**
     * Vrátí seznam ID objednávek a počty za jednotlivé stavy pro přehled veřejné části @param filterReqVO objekt s podmínkami pro filtrování @return list ID objednávek
     *
     * @param filterReqVO 
     * @return java.util.List<java.lang.Integer>
     */
    static getObjednavkaIds(filterReqVO) {
        const uri = serverContextPath + `/api/cgo/objednavka/prehledids`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, filterReqVO, headers));
    }

    /**
     * Přidání položek k existující objednávce @param objednavkaId id objednávky @param polozkaVOList seznam objektů položek objednávky @return aktualizovaná objednávka
     *
     * @param objednavkaId 
     * @param polozkaVOList 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaAkceResultVO
     */
    static addObjednavkaPolozky(objednavkaId, polozkaVOList) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/polozky/add`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, polozkaVOList, headers));
    }

    /**
     * Tisk zakázkového listu @param objednavkaId id objednávky @param response objekt pro návrat @throws IOException chyba při zpracování
     *
     * @param objednavkaId 
     */
    static tiskZakazka(objednavkaId) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/tiskZakazka`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Změna parametrů objednávky s validací a se zápisem do tabulky změn @param objednavkaId id objednávky, kterou chceme změnit @param objVO objekt pro přenos změn @return aktualizovaná objednávka
     *
     * @param objednavkaId 
     * @param objVO 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaAkceResultVO
     */
    static updateObjednavkaParametry(objednavkaId, objVO) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/zmenaparametry`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, objVO, headers));
    }

    /**
     * 
     *
     * @param objednavkaId 
     * @param polozkaParamsVOList 
     */
    static zalozPolozkyByParams(objednavkaId, polozkaParamsVOList) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/polozky`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, polozkaParamsVOList, headers));
    }

    /**
     * Vrátí seznam ID objednávek a počty za jednotlivé stavy pro přehled veřejné části @param filterReqVO objekt s podmínkami pro filtrování @return list ID objednávek
     *
     * @param filterReqVO 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaStavCountsVO
     */
    static getObjednavkaStavCount(filterReqVO) {
        const uri = serverContextPath + `/api/cgo/objednavka/prehledstavy`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, filterReqVO, headers));
    }

    /**
     * Smazání souboru @param objednavkaId id objednávky @param objednavkaSouborId id souboru
     *
     * @param objednavkaId 
     * @param objednavkaSouborId 
     */
    static deleteObjednavkaSoubor(objednavkaId, objednavkaSouborId) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/soubory/${objednavkaSouborId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.delete(uri, params));
    }

    /**
     * Změna kontaktních údajů objednávky s validací a se zápisem do tabulky změn @param objednavkaId id objednávky, kterou chceme změnit @param objVO objekt pro přenos změn @return aktualizovaná objednávka
     *
     * @param objednavkaId 
     * @param objVO 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaAkceResultVO
     */
    static updateObjednavkaKontakt(objednavkaId, objVO) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/zmenakontakt`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, objVO, headers));
    }

    /**
     * 
     *
     * @param objednavkaId 
     * @param nazevSmjSoubor 
     * @param pocet 
     * @param skladat 
     * @return java.util.List<cz.marbes.cgo.controller.vo.ObjednavkaPolozkaParamsVO>
     */
    static vypoctiPolozkyObjednavky(objednavkaId, nazevSmjSoubor, pocet, skladat) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/polozky/vypocet`;
        const headers = undefined;
        const params = { nazevSmjSoubor, pocet, skladat };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Změna stavu objednávky. @param objednavkaId id obj @return výsledný objekt
     *
     * @param objednavkaId 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaAkceResultVO
     */
    static updateObjednavkaStorno(objednavkaId) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/storno`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, 0, headers));
    }

    /**
     * Změna dopravy a platby objednávky s validací a se zápisem do tabulky změn @param objednavkaId id objednávky, kterou chceme změnit @param objVO objekt pro přenos změn @return aktualizovaná objednávka
     *
     * @param objednavkaId 
     * @param objVO 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaAkceResultVO
     */
    static updateObjednavkaDopravaPlatba(objednavkaId, objVO) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/zmenadopravaplatba`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, objVO, headers));
    }

    /**
     * 
     *
     * @return java.util.List<java.lang.String>
     */
    static vratSeznamSmj() {
        const uri = serverContextPath + `/api/cgo/objednavka/vratseznamsmj`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param objednavkaId 
     * @return java.util.Set<java.lang.String>
     */
    static getObjednavkaKodUkonSet(objednavkaId) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/ukonset`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Změna stavu objednávky. @param objednavkaId id obj @param novyStav nový stav @return výsledný objekt
     *
     * @param objednavkaId 
     * @param novyStav 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaAkceResultVO
     */
    static updateObjednavkaStav(objednavkaId, novyStav) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/zmenastav`;
        const headers = undefined;
        const params = { novyStav };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, 0, headers));
    }

    /**
     * Prvotní uložení objednávky, tak jak ji zadal uživatel. @param objVO objekt objednávky včetně úkonů a souborů s atributy. @return výsledný objekt
     *
     * @param objVO 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaAkceResultVO
     */
    static createObjednavka(objVO) {
        const uri = serverContextPath + `/api/cgo/objednavka/`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, objVO, headers));
    }

    /**
     * Stažení všech souborů dané objednávky v ZIP archivu. @param objednavkaId ID objednávky
     *
     * @param objednavkaId 
     */
    static getObjednavkaSoubory(objednavkaId) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/soubory`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vrátí přehled objednávek podle předaného seznamu ID @param ids id objednávek pro načtení @return list objednávek pro přehled
     *
     * @param ids 
     * @return java.util.List<cz.marbes.cgo.controller.vo.ObjednavkaPrehledVO>
     */
    static getObjednavkyPrehledByIds(ids) {
        const uri = serverContextPath + `/api/cgo/objednavka/prehledbyids`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, ids, headers));
    }

    /**
     * Přidání souboru k existující objednávce @param objednavkaId id objednávky @param souborVO objekt souboru @return nově založený soubor
     *
     * @param objednavkaId 
     * @param souborVO 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaSouborVO
     */
    static addObjednavkaSoubor(objednavkaId, souborVO) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/soubory/add`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, souborVO, headers));
    }

    /**
     * Aktualizace metadat vedených k souboru @param objednavkaId id objednávky @param objednavkaSouborId id souboru @param souborVO objekt souboru @return aktualizovaný soubor
     *
     * @param objednavkaId 
     * @param objednavkaSouborId 
     * @param souborVO 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaSouborVO
     */
    static updateObjednavkaSoubor(objednavkaId, objednavkaSouborId, souborVO) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/soubory/${objednavkaSouborId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, souborVO, headers));
    }

    /**
     * Stažení souboru dané objednávky. @param objednavkaId ID objednávky @param dokumentSouborId ID souboru dokumentu objednávky
     *
     * @param objednavkaId 
     * @param dokumentSouborId 
     */
    static getObjednavkaSoubor(objednavkaId, dokumentSouborId) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/soubor/${dokumentSouborId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vrátí objednávku podle předaného GUID @return objednáveka pro přehled
     *
     * @param guid 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaVO
     */
    static getObjednavkaByGuid(guid) {
        const uri = serverContextPath + `/api/cgo/objednavka/byGuid/${guid}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Změna stavu objednávky. @param objednavkaId id obj @return výsledný objekt
     *
     * @param objednavkaId 
     * @param objVO 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaAkceResultVO
     */
    static updateObjednavkaInterniPoznamka(objednavkaId, objVO) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/internipoznamka`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, objVO, headers));
    }

    /**
     * Dočasně uloží předané soubory a vrátí seznam kódů pro pozdější získání souborů. Kódy jsou vráceny dle pořadí souborů na vstupu. @param soubory soubory pro uložení @return seznam unikátních kódů pro pozdější získání souborů
     *
     * @param soubory 
     * @return java.util.List<java.lang.String>
     */
    static createTempSoubory(soubory) {
        const uri = serverContextPath + `/api/cgo/objednavka/soubory`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(Fetch.put(uri, params, 0, headers));
    }

    /**
     * Tisk cenové kalkulace objednávky @param objednavkaId id objednávky @param response objekt pro návrat @throws IOException chyba při zpracování
     *
     * @param objednavkaId 
     */
    static tiskKalkulace(objednavkaId) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/tiskKalkulace`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vrátí seznam ID objednávek a počty za jednotlivé stavy pro přehled veřejné části @param topx počet záznamů k vrácení @param filterReqVO objekt s podmínkami pro filtrování @return list ID objednávek
     *
     * @param topx 
     * @param filterReqVO 
     * @return java.util.List<cz.marbes.cgo.controller.vo.ObjednavkaPrehledVO>
     */
    static getObjednavkaTopX(topx, filterReqVO) {
        const uri = serverContextPath + `/api/cgo/objednavka/prehledtopx`;
        const headers = undefined;
        const params = { topx,  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, filterReqVO, headers));
    }

    /**
     * Klinknuti na odkaz objednávky. @param guid guid objednávky @param odpoved true/false nabidka byla schvalena/zamítnuta, null je pouhý link @return výsledný objekt
     *
     * @param guid 
     * @param odpoved 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaVO
     */
    static objednavkaLink(guid, odpoved) {
        const uri = serverContextPath + `/api/cgo/objednavka/objednavkalink`;
        const headers = undefined;
        const params = { guid, odpoved };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Změna názvu objednávky s validací a se zápisem do tabulky změn @param objednavkaId id objednávky, kterou chceme změnit @param objVO objekt pro přenos změn @return aktualizovaná objednávka
     *
     * @param objednavkaId 
     * @param objVO 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaAkceResultVO
     */
    static updateObjednavkaNakladStred(objednavkaId, objVO) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/zmenanaklstred`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, objVO, headers));
    }

    /**
     * Smazání položky na existující objednávce @param objednavkaId id objednávky @param objednavkaPolozkaId id položky objednávky ke smazání @return aktualizovaná objednávka
     *
     * @param objednavkaId 
     * @param objednavkaPolozkaId 
     * @return cz.marbes.cgo.controller.vo.ObjednavkaAkceResultVO
     */
    static deleteObjednavkaPolozka(objednavkaId, objednavkaPolozkaId) {
        const uri = serverContextPath + `/api/cgo/objednavka/${objednavkaId}/polozky/${objednavkaPolozkaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.delete(uri, params));
    }

}
